import type { ReactNode } from 'react';
import { ProvidersNav } from './ProvidersNav';

/** Shared section chrome for the Providers pages: container + title + nav. */
export function ProvidersShell({ children }: { children: ReactNode }) {
  return (
    <div className="max-w-7xl mx-auto px-4 py-8 sm:px-6 lg:px-8">
      <h1 className="text-2xl font-bold mb-4">Providers</h1>
      <ProvidersNav />
      {children}
    </div>
  );
}
